/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useEffect, useState } from 'react'

interface OrdersContextProps {
  orderId: number
  setOrderId: React.Dispatch<React.SetStateAction<number>>
  originDealId: number
  setOriginDealId: React.Dispatch<React.SetStateAction<number>>
  quantity: number
  setQuantity: React.Dispatch<React.SetStateAction<number>>
  status: string
  setStatus: React.Dispatch<React.SetStateAction<string>>
  statusId: number
  setStatusId: React.Dispatch<React.SetStateAction<number>>
  orderNumber: number
  setOrderNumber: React.Dispatch<React.SetStateAction<number>>
}



const OrdersContext = createContext<OrdersContextProps>({
  orderId: 0,
  setOrderId: () => {},
  originDealId: 0,
  setOriginDealId: () => {}, 
  quantity: 9,
  setQuantity: () => {},
  status: '',
  setStatus: () => {
  },
  statusId: 0,
  setStatusId: ()=>{

  },
  orderNumber: 0,
  setOrderNumber: ()=>{

  }
})

export default OrdersContext

export const OrdersProvider: React.FC<any> = ({ children }) => {
  const [ orderId, setOrderId ] = useState<number>(0)
  const [ originDealId, setOriginDealId ] = useState<number>(0)
  const [ quantity, setQuantity ] = useState<number>(9)
  const [ status, setStatus ] = useState<string>('')
  const [statusId, setStatusId] = useState<number>(0)
  const [orderNumber, setOrderNumber] = useState<number>(0)

  return (
    <OrdersContext.Provider
      value={{
        orderId,
        setOrderId,
        originDealId,
        setOriginDealId,
        quantity,
        setQuantity,
        status,
        setStatus,
        statusId,
        setStatusId,
        orderNumber,
        setOrderNumber
      }}
    >
      {children}
    </OrdersContext.Provider>
  )
}
